<template>
    <!-- <div class="content" role="menu">
      <div
        role="menuitem"
        tabindex="0"
        @click="jumpHome"
        class="list-item"
        v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 1 })"
      >
        <em class="icon homepage"></em>
        <span>首页</span>
      </div>
      <div
        tabindex="0"
        role="menuitem"
        @click="refresh"
        class="list-item"
        v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 8 })"
      >
        <em class="icon refresh"></em>
        <span>刷新</span>
      </div>
      <div
        tabindex="0"
        role="menuitem"
        class="list-item"
        v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 2 })"
        @click="jump(`${linkBase}/my/favorite`)"
      >
        <em class="icon favorites"></em>
        <span>我的收藏</span>
      </div>
      <template v-if="isHeader">
        <div
          tabindex="0"
          role="menuitem"
          path="/my/order"
          class="list-item"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 3 })"
          @click="jump(`${linkBase}/my/order`)"
        >
          <em class="icon orders"></em>
          <span>我的订单</span>
        </div>
        <div
          tabindex="0"
          role="menuitem"
          @click="showHistory"
          class="list-item"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 4, taskType: 1 })"
        >
          <em class="icon history"></em>
          <span>浏览记录</span>
        </div>
        <div
          tabindex="0"
          role="menuitem"
          v-if="showSug"
          @click="deeplinkSug"
          class="list-item"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 5 })"
        >
          <em class="icon suggestion"></em>
          <span>意见反馈</span>
        </div>
      </template>
      <template v-else>
        <OutLink
          tabindex="0"
          role="menuitem"
          path="/my"
          class="list-item"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 6 })"
        >
          <em class="icon center"></em>
          <span>个人中心</span>
        </OutLink>
        <OutLink
          tabindex="0"
          role="menuitem"
          path="/category"
          class="list-item"
          v-if="!env.isIOSVivoApp"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 7 })"
        >
          <em class="icon category"></em>
          <span>全部分类</span>
        </OutLink>
      </template>
    </div>
 -->

  <nx-dropdown-menu  
    v-model="value" 
    :show.sync="isShowMenu" 
    :list="menuList" 
    popPosition="right"
    type="normal" 
    @change="handleSelectMenu"
  >
    <template v-slot:menuIcon>
      <div
        class="icon menu"
        v-track="menuIconTrackData"
        tabindex="0"
        role="button"
        aria-label="更多"
      >
         <v-icon class="i-menu" name="icon-menu-v3"></v-icon>
      </div>
    </template>
  </nx-dropdown-menu>

</template>

<script>
import { mapGetters } from 'vuex'
import env from '@/utils/clientEnv'
// import { OutLink } from '@/components'
import app from '@/utils/app'
import { jumpToHome } from '@/utils/common'
import { DropdownMenu  } from '@vivo/vos-ui'
export default {
  name: 'MenuList',
  components: {
    // OutLink,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    // 是否为头部的汉堡菜单
    isHeader: {
      type: Boolean,
      default: false
    },
    menuIconTrackData: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  computed: {
    ...mapGetters('detailv3', ['skuId']),
    menuList(){
      return [{
        value: 'jumpHome',
        text: '首页'
      },{
        value: 'refresh',
        text: '刷新'
      },{
        value: 'jumpFavorite',
        text: '我的收藏'
      }].concat(this.isHeader ? [{
        value: 'jumpOrder',
        text: '我的订单'
      },{
        value: 'showHistory',
        text: '浏览记录'
      }].concat( this.showSug ? [{
        value: 'deeplinkSug',
        text: '意见反馈'
      }] : []) : ([{
        value: 'jumpMy',
        text: '个人中心'
      }].concat(env.isIOSVivoApp ? []:[{
        value: 'jumpCategory',
        text: '全部分类'
      }])))
    }
  },
  data() {
    return {
      value: '',
      isShowMenu: false,
      showSug: env.isDefaultHideTitle,
      env
    }
  },
  watch: {
    // 防止滚动穿透
    isShowMenu(val) {
      this.value = ''
    }
  },
  methods: {
    handleSelectMenu(value, item) {
      this.$nextTick(()=>{
        this[value]&& this[value]()
      })
    },
    showHistory() {
      this.menuClick({ titlebar_content: 4, taskType: 1 })
      this.$emit('showHistory')
    },
    // 跳转意见反馈
    deeplinkSug() {
      this.menuClick({ titlebar_content: 5 })
      app.openAppByDeepLink({
        deepLink: 'space://vivo.com/faqhome'
      })
    },
    preventEvent(e) {
      e.preventDefault()
      e.stopPropagation()
    },
    async jumpHome() {
      this.menuClick({titlebar_content: 1})
      jumpToHome()
    },
    refresh() {
      this.menuClick({titlebar_content: 8})
      location.reload()
    },
    jumpFavorite(){
      this.menuClick({titlebar_content: 2})
      this.jump(`${this.linkBase}/my/favorite`)
    },
    jumpOrder(){
      this.menuClick({titlebar_content: 3})
      this.jump(`${this.linkBase}/my/order`)
    },
    jumpMy(){
      this.menuClick({titlebar_content: 6})
      this.jump(`${this.linkBase}/my`)
    },
    jumpCategory(){
      this.menuClick({titlebar_content: 7})
      this.jump(`${this.linkBase}/category`)
    },
    jump(url) {
      app.openNewWebview({ url: url })
    },
    menuClick({ titlebar_content, taskType }){
      const page_name = 1
      this.$track({
        cfrom: '170|002|01|077',
        event_id: '170|002|01|077',
        taskType: taskType || 2,
        sku_id: this.skuId,
        titlebar_content,
        page_name
      })
    }
  }
}
</script>

<style lang="scss">
.vp-header-show-app {
  .menu-list {
    top: 285px !important;
    &::after {
      top: 307px !important;
    }
  }
}
</style>

<style lang="scss" scoped src="./index.scss"></style>
